/*
 * @Author: 曹小丽
 * @Description:
 * @Date: 2022-04-19 09:56:07
 * @LastEditTime: 2022-04-21 14:16:37
 * @FilePath: \insurforce-backstage-platform-side\src\views\policy\customerManage\request.js
 */
import request from '@/utils/request2';
export function policyList(data) {
  return request.post('admin/policy/list', data);
}
export function downloadPolicy(data) {
  return request.post('admin/policy/export', data);
}
export function policyDetail(data) {
  return request.post('admin/policy/detail', data);
}
//手动录入
export function addPolicy(data) {
  return request.post('admin/policy/store', data);
}
//手动录入校验
export function policyVerifyy(data) {
  return request.post('admin/policy/check-field', data);
}
// 申请理赔
export function claimsApplyAuditStore(data, type) {
  const url = type == 2 ? 'admin/audit/claims/store' : 'admin/claims/store';
  return request.post(url, data);
}
//理赔校验
export function claimsVerifyy(data) {
  return request.post('admin/claims/verify', data);
}
//下载保单
export function policyZip(data) {
  return request.post('admin/policy/zip', data);
}
export function exportZip(data) {
  return request.post('admin/policy/export-zip', data);
}
export function getTags(data) {
  return request.post('admin/policy/getTags', data);
}
export function planRelateData(data) {
  return request.post('admin/policy/plan-related-data', data);
}
export function getPersonnelDetail(data) {
  return request.post('admin/policy/personnel-details/resource', data);
}
export function savePersonnelEntry(data) {
  return request.post('admin/policy/personnel-details/store', data);
}
export function getOccupationResource(data) {
  return request.post('admin/policy/occupation/resource', data);
}
export function getPersonnelDetailList(data) {
  return request.post('admin/policy/personnel-details/list', data);
}
export function personnelDetailsRecordPrompt(data) {
  return request.post('admin/policy/personnel-details-record/export/prompt', data);
}
export function personnelDetailsRecord1(data) {
  return request.post('admin/policy/personnel-details-record/list', data);
}
export function personnelDetailsRecordDetail1(data) {
  return request.post('admin/policy/personnel-details-record/detail', data);
}

// 保单号资源
export function policyNoResource(data) {
  return request.post('admin/policy/personnel-details-record/policyNo/resource', data);
}
// 操作人资源
export function operatorResource(data) {
  return request.post('admin/policy/personnel-details-record/operator/resource', data);
}
//批量导入校验
export function batchVerify(data) {
  return request.post('admin/policy/personnel-details/batch-verify', data);
}
//批量导入人员明细
export function batchImport(data) {
  return request.post('admin/policy/personnel-details/batch', data);
}
// 人员减员
export function personnelDetailReduction(data) {
  return request.post('admin/policy/personnel-details/reduction', data);
}
// 导出人员明细
export function personnelDetailExport(data) {
  return request.post('admin/policy/personnel-details-record/export', data);
}
export function personnelDetailsDetail(data) {
  return request.post('admin/policy/personnel-details/detail', data);
}

//批单列表
export function endorsementList(data) {
  return request.post('admin/policy/personnel-details/endorsement-list', data);
}

//获取批量减员的每一个保单的保单的起止日期
export function batchRedutionBorder(data) {
  return request.post('admin/policy/personnel-details/batch-reduction-border', data);
}
//批量减员校验
export function batchReductionVerify(data) {
  return request.post('admin/policy/personnel-details/batch-reduction-verify', data);
}
//批量减员导入
export function batchReduction(data) {
  return request.post('admin/policy/personnel-details/batch-reduction', data);
}
//人员明细导出
export function personnelDetailsExport(data) {
  return request.post('admin/policy/personnel-details/export', data);
}

//生成批单 生成并发送批单
export function endorsementCreate(data) {
  return request.post('admin/policy/personnel-details-record/endorsement-export', data);
}
export function checkAndPreviewEndorsement(data) {
  return request.post('admin/policy/personnel-details-record/check-endorsement-export', data);
}
//批单 人员明细 发送至邮箱
export function exportSendEmail(data) {
  return request.post('/admin/policy/personnel-details-record/export-send-email', data);
}
export function endorsementExportSend(data) {
  return request.post('admin/policy/personnel-details-record/endorsement-export-send', data);
}
// 编辑
export function personnelDetailEdit(data) {
  return request.post('admin/policy/personnel-details/edit', data);
}
export function insuredPersonnelList(data) {
  return request.post('admin/policy/correct/list', data);
}
export function correctionRecordList(data) {
  return request.post('admin/policy/correct-record/list', data);
}
export function correctionRecordDetail(data) {
  return request.post('admin/policy/correct-record/detail', data);
}
export function correctionRecordExport(data) {
  return request.post('admin/policy/correct-record/personnel-export', data);
}
export function batchRecordExport(data) {
  return request.post('admin/policy/correct-record/export', data);
}
export function batchDownRecordVerify(data) {
  return request.post('admin/policy/correct-record/export-verify', data);
}
export function recordExportVerify(data) {
  return request.post('admin/policy/correct-record/personnel-export-verify', data);
}
export function correctBatchImportVerify(data) {
  return request.post('admin/policy/correct/batch-verify', data);
}
export function correctSure(data) {
  return request.post('admin/policy/correct/batch-sort', data);
}
export function groupInsuranceBatchSort(data) {
  return request.post('admin/v2/group-insurance/batch-sort', data);
}
export function correctSureVerify(data) {
  return request.post('admin/policy/correct/confirm-verify', data);
}
export function policyResource(data) {
  return request.post('admin/policy/correct/resource-verify', data);
}
export function policyNoEdit(data) {
  return request.post('admin/policy/edit', data);
}
export function groupRecordDownload(data) {
  //爱柚味产品批量下载
  return request.post('admin/v2/group-insurance/correct-record-export', data);
}